module.exports = __webpack_public_path__ + "img/modal-document-clone.e53d315c.svg";